import { useEffect, useMemo, useRef, useState } from "react";
import { STORAGE_KEY } from "../utils/draftutils";
import { isLeaf } from "../utils/gerarchiautils";

export default function useDrafts() {
  const [drafts, setDrafts] = useState([]);
  const [radice, setRadice] = useState(null);

  // load
  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        setDrafts(arr);
        setRadice(arr.find((d) => d.isRadice) || null);
      }
    } catch {}
  }, []);

  // save (debounced)
  const t = useRef(null);
  useEffect(() => {
    clearTimeout(t.current);
    t.current = setTimeout(() => {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts)); } catch {}
    }, 350);
    return () => clearTimeout(t.current);
  }, [drafts]);

  const hasAnyLeaf = useMemo(() => drafts.some(isLeaf), [drafts]);

  return { drafts, setDrafts, radice, setRadice, hasAnyLeaf };
}
